// extracted by mini-css-extract-plugin
export default {"customersTable":"Eso6rkM05xOzYn43vpPd","searchInput":"pPFq3d_UA3o9EHVjpzqO","customerRow":"QE3e98NYcLIZGRMU6RcM"};